import { Reveal } from '../Reveal';
import { SectionHeader } from '../SectionHeader';
import { CheckList, DemoCaption, PhoneFrame } from '../compass/shared';

// Section 5 — timesheets and approvals. Two-column with the desktop
// timesheets view and the employee mobile visual.
export const PulseTimesheets = ({ sp }) => (
  <section aria-labelledby="pulse-timesheets-heading" data-testid="pulse-timesheets" className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-14 lg:grid-cols-2">
        <Reveal>
          <SectionHeader
            align="left"
            eyebrow="Time & Approvals"
            title="Make employee time easier to record and control"
            description={sp.timesheetsCopy}
            testid="pulse-timesheets-header"
          />
          <div className="mt-8">
            <CheckList items={sp.timesheetsPoints || []} testid="pulse-timesheets-points" />
          </div>
        </Reveal>
        <Reveal delay={0.12} className="relative">
          <figure className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-lift">
            <img
              src={sp.shots.timesheets.src}
              alt={sp.shots.timesheets.alt}
              width={sp.shots.timesheets.width}
              height={sp.shots.timesheets.height}
              loading="lazy"
              className="w-full"
              data-testid="pulse-timesheets-visual"
            />
          </figure>
          <div className="absolute -bottom-8 -left-2 hidden w-32 sm:block lg:-left-6 lg:w-36">
            <PhoneFrame shot={sp.shots.employeeMobile} />
          </div>
          <DemoCaption className="sm:pl-40 sm:text-right" />
        </Reveal>
      </div>
    </div>
  </section>
);
